import React, { Component } from 'react'

import Axios from 'axios'
import '../../custom.css'
// import PlacesAutocomplete from './GetRiderDeoCord';
import K from '../../services/k'
import swal from 'sweetalert'
import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import InputAdornment from '@material-ui/core/InputAdornment'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
// import Input from "@material-ui/core/Input";

class PersonalDetails extends Component {
  state = {
    fields: {},
    isLoading: false,
    errors: {},
    address: '',
    success: {},
    isSuccess: false,
    showPassword: false,
    options: {
      types: ['(cities)'],
    },
  }

  imageFileRef = React.createRef()

  handleValidation = () => {
    let fields = this.state.fields
    let errors = {}
    let formIsValid = true
    //avatar

    if (!fields['image']) {
      formIsValid = false
      errors['image'] = 'Avatar Cannot be empty'
    }
    //phone

    if (!fields['phone']) {
      formIsValid = false
      errors['phone'] = 'Phone number Cannot be empty'
    }

    //Name
    if (!fields['first_name']) {
      formIsValid = false
      errors['first_name'] = 'first name Cannot be empty'
    }
    if (!fields['last_name']) {
      formIsValid = false
      errors['last_name'] = 'last name Cannot be empty'
    }

    //Email
    if (!fields['email']) {
      formIsValid = false
      errors['email'] = 'email address Cannot be empty'
    }

    if (typeof fields['email'] !== 'undefined') {
      let lastAtPos = fields['email'].lastIndexOf('@')
      let lastDotPos = fields['email'].lastIndexOf('.')

      if (
        !(
          lastAtPos < lastDotPos &&
          lastAtPos > 0 &&
          fields['email'].indexOf('@@') === -1 &&
          lastDotPos > 2 &&
          fields['email'].length - lastDotPos > 2
        )
      ) {
        formIsValid = false
        errors['email'] = 'Email is not valid'
      }
    }
    const validatePwd = this.validatePassword()

    if (validatePwd === false) {
      formIsValid = false
      errors['password'] =
        'Weak Password - Please ensure passwords are more than 8 characters long and contain at least:  1 Number, 1 Capital Letter, 1 Special Character'
    }

    const passwordMatch = this.checkPasswordMatch(
      fields['password'],
      fields['password_confirmation'],
    )
    if (passwordMatch === false) {
      formIsValid = false
      errors['password_confirmation'] =
        'Passwords do not match.  Please try again.'
    }
    const validatePhone = this.validatePhoneNumber()

    if (validatePhone === false) {
      formIsValid = false
      errors['phone'] = 'invalid phone number'
    }

    this.setState({ errors: errors })
    return formIsValid
  }

  validatePhoneNumber = () => {
    const phone_number = this.state.fields.phone
    const phonRejex =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im

    if (!phonRejex.test(phone_number)) {
      return false
    }

    if (phone_number.length <= 9) {
      return false
    }
  }

  getCoordinate = (coord, address) => {
    this.setState({ address })
    this.handleChange.bind(this, 'latitude')
    this.handleChange.bind(this, 'longitude')
    this.state.fields['longitude'] = coord.lng
    this.state.fields['latitude'] = coord.lat
  }

  validatePassword = () => {
    var newPassword = this.state.fields['password']
    var regularExpression = new RegExp(
      '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})',
    )

    if (!regularExpression.test(newPassword)) {
      return false
    }
    if (newPassword.length < 8) {
      return false
    }
  }
  handleClickShowPassword = (e) => {
    e.preventDefault()
    this.setState({
      showPassword: !this.state.showPassword,
    })
  }

  contactSubmit = async (e) => {
    e.preventDefault()

    if (this.handleValidation()) {
      this.setState({ isLoading: true })
      const data = new FormData()
      data.append('email', this.state.fields['email'])
      data.append('password', this.state.fields['password'])
      data.append('last_name', this.state.fields['last_name'])
      data.append('first_name', this.state.fields['first_name'])
      data.append('middle_name', this.state.fields['last_name'])
      data.append('phone_number', this.state.fields['phone'])
      data.append('email_address', this.state.fields['email'])
      data.append('image', this.state.fields['image'])

      await Axios.post(K.riderRegister, data, {
        'Content-type': 'multipart/form-data',
      })
        .then((response) => {
          console.log(response)
          if (
            response &&
            response.data &&
            response.data.message.indexOf('log in') > -1
          ) {
            this.props.logOut()
            return
          }
          let data = response.data
          if (data.success) {
            localStorage.setItem('rider_id', data.id)
            localStorage.setItem('rider_email', data.email)
            localStorage.setItem('rider_pwd', this.state.fields['password'])

            this.setState({ isLoading: false })
            this.setState({ isSuccess: true })
            this.state.success['success'] =
              'Check your mailbox to Update profile details'

            swal({
              title: 'Success!',
              text: `SUCCESS!!
              To finish saddling up, please check your email within 3-5 minutes for a verification link.
              You will be asked to fill out an important Roadie registration form, and then…
              YOU’RE OFF!!`,
              icon: 'success',
              timer: null,
              closeOnClickOutside: false,
            })
          } else {
            this.state.errors['server'] = data.message
            this.setState({ isLoading: false })
          }
        })
        .catch((error) => {
          console.log(error)

          this.state.errors['server'] =
            'Account Creation failed, Server Error(Please Contact Customer Support)'

          this.setState({ isLoading: false })
        })
    } else {
      let errors = this.state.errors
      let formErrors = []

      Object.keys(errors).map((error, index) => {
        formErrors.push(`${errors[error]}`)
      })

      swal({
        title: 'Warning!',
        text: `${formErrors}\n`,
        icon: 'warning',
        timer: 5000,
      })
    }
  }
  handleChange = (field, e) => {
    let fields = this.state.fields
    fields[field] = e.target.value
    this.setState({ fields })
  }

  checkPasswordMatch = (password, password_confirmation) => {
    return password === password_confirmation ? true : false
  }

  onSelectFile = (e) => {
    let fields = this.state.fields
    if (e.target.files && e.target.files.length > 0) {
      fields['image'] = e.target.files[0]
      let _this = this
      const fileReader = new FileReader()
      fileReader.readAsDataURL(fields['image'])
      fileReader.addEventListener('load', function () {
        fields['image_data'] = this.result
        _this.setState({ fields })
      })
    } else {
      fields['image_data'] = ''
      this.setState({ fields })
    }
  }

  createImageUrlFromFile = (e) => {
    if (e) {
      return e
    }
    return '../images/become-rider.jpg'
  }

  render() {
    return (
      <div>
        <div className="main-wrapper inner--page">
          <section className="login">
            <div className="container">
              <div className="row">
                <div className="col-lg-10 offset-lg-1 col-md-12 offset-md-1">
                  <div className="login-content">
                    <div className="heading-text text-center">
                      <h3>Roadie Sign Up</h3>
                      <h6 className="red">
                        (Make sure you live in jamaica before sign up!)
                      </h6>
                    </div>

                    <div className="login-form">
                      <form onSubmit={this.contactSubmit}>
                        <div className="row">
                          <div
                            className="col-lg-12"
                            style={{ marginTop: 30, marginBottom: 30 }}
                          >
                            <div className="form-group">
                              <input
                                ref={this.imageFileRef}
                                style={{ display: 'none' }}
                                type="file"
                                onChange={this.onSelectFile}
                              />
                              <div style={{ textAlign: 'center' }}>
                                <div
                                  style={{
                                    position: 'relative',
                                    width: 64,
                                    margin: 'auto',
                                  }}
                                  className="avatar-select"
                                  onClick={() => {
                                    if (
                                      this.imageFileRef.current !== undefined &&
                                      this.imageFileRef.current.click !==
                                        undefined
                                    )
                                      this.imageFileRef.current.click()
                                  }}
                                >
                                  <img
                                    style={{
                                      border: '1px solid black',
                                      width: 64,
                                      height: 64,
                                      borderRadius: '50%',
                                      cursor: 'pointer',
                                    }}
                                    src={this.createImageUrlFromFile(
                                      this.state.fields['image_data'],
                                    )}
                                  />
                                  <i
                                    style={{
                                      position: 'absolute',
                                      bottom: 0,
                                      right: 24,
                                      top: 24,
                                    }}
                                    className="fas fa-edit"
                                  ></i>
                                </div>
                              </div>
                              <span style={{ color: 'red' }}>
                                {this.state.errors['image']}
                              </span>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>First Name</label>
                              <input
                                type="text"
                                size="30"
                                placeholder="First Name"
                                onChange={this.handleChange.bind(
                                  this,
                                  'first_name',
                                )}
                                value={this.state.fields['first_name']}
                              />
                              <span style={{ color: 'red' }}>
                                {this.state.errors['first_name']}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Last Name</label>
                              <input
                                type="text"
                                size="30"
                                placeholder="Last Name"
                                onChange={this.handleChange.bind(
                                  this,
                                  'last_name',
                                )}
                                value={this.state.fields['last_name']}
                              />
                              <span style={{ color: 'red' }}>
                                {this.state.errors['last_name']}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Phone Number</label>
                              <input
                                type="text"
                                size="30"
                                placeholder="Phone Number"
                                onChange={this.handleChange.bind(this, 'phone')}
                                value={this.state.fields['phone']}
                              />
                              <span style={{ color: 'red' }}>
                                {this.state.errors['phone']}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Email</label>

                              <input
                                type="text"
                                size="30"
                                placeholder="Email"
                                onChange={this.handleChange.bind(this, 'email')}
                                value={this.state.fields['email']}
                              />
                              <span style={{ color: 'red' }}>
                                {this.state.errors['email']}
                              </span>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Password</label>
                              <div className="">
                                <input
                                  type={
                                    this.state.showPassword
                                      ? 'text'
                                      : 'password'
                                  }
                                  size="30"
                                  placeholder="Password"
                                  onChange={this.handleChange.bind(
                                    this,
                                    'password',
                                  )}
                                  value={this.state.fields['password']}
                                />
                                <InputAdornment
                                  position="end"
                                  style={{
                                    marginTop: '-20px',
                                    marginLeft: '90%',
                                  }}
                                >
                                  <IconButton
                                    onClick={this.handleClickShowPassword}
                                  >
                                    {this.state.showPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Confirm Password</label>
                              <div className="">
                                <input
                                  type={
                                    this.state.showPassword
                                      ? 'text'
                                      : 'password'
                                  }
                                  size="30"
                                  placeholder="Password confirmation"
                                  onChange={this.handleChange.bind(
                                    this,
                                    'password_confirmation',
                                  )}
                                  value={
                                    this.state.fields['password_confirmation']
                                  }
                                />
                                <InputAdornment
                                  position="end"
                                  style={{
                                    marginTop: '-20px',
                                    marginLeft: '90%',
                                  }}
                                >
                                  <IconButton
                                    onClick={this.handleClickShowPassword}
                                  >
                                    {this.state.showPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-12" style={{ marginTop: 30 }}>
                            <div className="form-group">
                              <span style={{ color: 'red' }}>
                                {this.state.errors['server']}
                              </span>{' '}
                              <br />
                              {/* <span>
                              <p style={{ color: "green" }}>{this.state.isSuccess ? "Success!!  In order to finish saddling up, please check your email for verification link.": ""}</p>
                            </span>  */}
                              <br />
                              {this.state.isLoading ? (
                                'Submitting please wait ...'
                              ) : (
                                <button
                                  className="primary-btn"
                                  type="submit"
                                  onClick={this.handleSubmit}
                                >
                                  Register
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    )
  }
}

export default PersonalDetails
